export default "__VITE_ASSET__u$uRxOjA__"